<template>
    <div>
        <v-data-table
                class="product-list"
                :headers="headers"
                :items="productsList"
                hide-actions
        >
            <template
                    slot="headerCell"
                    slot-scope="{ header }">
              <span class="subheading font-weight-light text-success text--darken-3"
                    v-text="header.text"/>
            </template>
            <template
                    slot="items"
                    slot-scope="{ item }">
                <td class="text-xs-left ">
                    <img v-if="item.images.length" :src="item.images[0].image_medium" alt="">
                </td>
                <td class="text-xs-left">
                    <span class="user-link"
                          @click="SET_PRODUCT_CARD(item.product_id)">                          {{ item.vendor_code }} </span></td>
                <td class="text-xs-left">{{ item.title }}</td>
                <td class="text-xs-left">{{ item.count }}</td>
                <td class="text-xs-left">{{ item.conditional_price }}</td>
                <td class="text-xs-right">{{ item.count*item.conditional_price }}</td>
            </template>
        </v-data-table>
        <ProductCard/>


    </div>
</template>

<script>
    import {mapMutations} from 'vuex';
    import ProductCard from "./ProductCard";

    export default {
        components: {ProductCard},
        data: () => ({
            headers: [
                {
                    sortable: false,
                    text: 'Изображение',
                    value: 'images'
                },
                {
                    sortable: false,
                    text: 'Артикул',
                    value: 'vendor_code'
                },
                {
                    sortable: false,
                    text: 'Наименование',
                    value: 'title'
                },
                {
                    sortable: false,
                    text: 'Кол-во',
                    value: 'count'
                },
                {
                    sortable: false,
                    text: 'Цена',
                    value: 'conditional_price'
                },
                {
                    sortable: false,
                    text: 'Итого',
                    value: 'reward',
                    align: 'right'
                }
            ],
        }),
        props: ['productsList'],
        methods: {
            ...mapMutations(['SET_PRODUCT_CARD'])
        }
    }
</script>

<style>
    .product-list img {
        margin-right: 20px;
        object-fit: contain;
        height: 70px;
        padding-right: 20px;

    }
</style>
